'use strict';

const A11yToolInitializer = require('grpn-fix-a11y/lib/initializer');

const FixA11y = {
  init({ fixA11y }, done) {
    if (fixA11y) {
      A11yToolInitializer(fixA11y);
    }

    return done();
  },
};

module.exports = FixA11y;
